const API_URL = process.env.REACT_APP_API_URL;
const OLD_API_URL = process.env.REACT_APP_OLD_API_URL || process.env.REACT_APP_API_URL;  // fall back if old isn't provided

const OLD_API_PATHS = [
  "utils/upload-image",
  "orders/designer/print-message",
  "orders/mass-print-message",
]
export const getAPIURL = (path) => {
  const baseURL = OLD_API_PATHS.includes(path) ? OLD_API_URL : API_URL;
  return baseURL + path;
}